export const ORDER_SET = 'at/taskManagement/tasksTable/configurationMenu/ORDER_SET'
export const SELECTED_SET = 'at/taskManagement/tasksTable/configurationMenu/SELECTED_SET'
export const IS_SUMMARY_ROW_SHOWN_SET = 'at/taskManagement/tasksTable/configurationMenu/IS_SUMMARY_ROW_SHOWN_SET'



// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/configurationMenu/actionTypes.js